export default __webpack_public_path__ + "static/media/Fraunhofer-DarkModeSpheres_masked_de.30306c8d.jpg";